let id = 0;

export default function getId(){
    return id++
}